import queryString from "query-string";
import { PureComponent } from "react";

import * as CalculatorStepTracker from "@/services/tracking/trackers/tools/calculators/calculatorStep.tracker";
import { CALCULATOR_KEYS } from "@/services/tracking/trackers/tools/calculators/config";
import { asyncState, validNumber } from "@/utils/calculators";

import Calculation from "./calculation/calculation.component";
import Result from "./result/result.component";

type TileCalculatorState = {
    roomLength: number;
    roomWidth: number;
    roomArea: number;
    tileWidth: number;
    tileLength: number;
    tileArea: number;
    packageArea: number;
};

class TileCalculator extends PureComponent<{}, TileCalculatorState> {
    query = queryString.parse(location.search);

    constructor(props: {}) {
        super(props);

        this.state = {
            roomLength: this.query.roomLength
                ? Number(this.query.roomLength)
                : 0,
            roomWidth: this.query.roomWidth ? Number(this.query.roomWidth) : 0,
            tileWidth: this.query.tileWidth ? Number(this.query.tileWidth) : 0,
            tileLength: this.query.tileLength
                ? Number(this.query.tileLength)
                : 0,
            packageArea: this.query.packageArea
                ? Number(this.query.packageArea)
                : 0,
            roomArea: 0,
            tileArea: 0
        };
    }

    async componentDidMount() {
        await asyncState(this, {
            roomArea: this.roomArea(),
            tileArea: this.tileArea()
        });

        CalculatorStepTracker.trackStart(CALCULATOR_KEYS.tile);
    }

    // calculations
    roomArea = () => {
        let roomArea = 0;

        const roomLength = this.state.roomLength;

        const roomWidth = this.state.roomWidth;

        if (validNumber(roomLength) && validNumber(roomWidth)) {
            roomArea = roomLength * roomWidth;
        }

        return Number(roomArea);
    };
    tileArea = () => {
        let tileArea = 0;

        const tileLength = this.state.tileLength;

        const tileWidth = this.state.tileWidth;

        if (validNumber(tileLength) && validNumber(tileWidth)) {
            tileArea = tileLength * tileWidth * 0.01 * 0.01;
        }

        return Number(tileArea);
    };

    // setters
    setCalculationValue = (field: string, value: string) => {
        const numberValue = parseFloat(value.replace(",", "."));
        this.setState(
            (state) => ({ ...state, [field]: numberValue }),
            () => {
                this.setState({
                    roomArea: this.roomArea(),
                    tileArea: this.tileArea()
                });
            }
        );

        CalculatorStepTracker.trackSubmit(CALCULATOR_KEYS.tile);
    };

    render() {
        const calculationProps = {
            setCalculationValue: this.setCalculationValue,
            roomLength: this.state.roomLength,
            roomWidth: this.state.roomWidth,
            tileWidth: this.state.tileWidth,
            tileLength: this.state.tileLength,
            packageArea: this.state.packageArea
        };
        const resultProps = {
            roomArea: this.state.roomArea,
            tileArea: this.state.tileArea,
            packageArea: this.state.packageArea,
            mailParams: {
                roomLength: this.state.roomLength,
                roomWidth: this.state.roomWidth,
                tileWidth: this.state.tileWidth,
                tileLength: this.state.tileLength,
                packageArea: this.state.packageArea
            }
        };

        return (
            <div id="calculator">
                <Calculation {...calculationProps} />
                <Result {...resultProps} />
            </div>
        );
    }
}

export { TileCalculator };
